import { type ReactNode } from 'react';
import type { Creator } from '@/types';
import {
  INACTIVE_ACCOUNT_STATUS_LABELS,
  isInactiveAccountStatus,
} from '@/utils/account-status';

type Props = { creator: Creator };

// Muestra el username del collector que apeló / es owner del lead. Si el
// collector está inactivo (banned / failed / deleted) añade un sufijo
// para que el admin sepa que ese lead requiere su atención porque el
// owner ya no actuará.
export function CollectorPill({ creator }: Props): ReactNode {
  const c = creator.expand?.collector;
  if (!c) return <span className="text-text-tertiary text-xs">sin owner</span>;
  const status = c.account_status;
  const inactive = isInactiveAccountStatus(status);
  const suffix =
    inactive && status ? INACTIVE_ACCOUNT_STATUS_LABELS[status] : '';
  return (
    <span className="inline-flex items-center gap-xs text-xs">
      <span className="text-text-secondary">
        @{c.ig_username || c.first_name}
      </span>
      {inactive && (
        <span className="rounded-full bg-error/10 px-sm py-0.5 text-[10px] uppercase tracking-wide text-error">
          {suffix || 'inactivo'}
        </span>
      )}
    </span>
  );
}
